// extracted by mini-css-extract-plugin
module.exports = {"surveyPage":"styles-module__surveyPage___3n7bC","survey-section":"styles-module__survey-section___3HyR3","footer":"styles-module__footer___2KK-2"};